<template>
  <div class="">
    <search-group title="" @search="findData" @clear="clearValue">
      <Row :gutter="16" class="mb8">
        <Col span="5">
        <Input type="text" placeholder="关键字" v-model="searchData.keywords" ></Input>
        </Col>
        <Col span="5">
        <Select :filterable="true"  v-model="searchData.cityCode" placeholder="城市" clearable @on-change="changeCity">
          <Option v-for="(item,index) in cityList" :value="item.value" :key="'keyA'+index">{{item.text}}</Option>
        </Select>
        </Col>
        <Col span="5" v-show="bizcircleList!=null&&bizcircleList.length!=0">
        <Select :filterable="true"  v-model="searchData.bizcircleName" placeholder="商圈" clearable>
          <Option v-for="(item,index) in bizcircleList" :value="item.value" :key="'keyH'+index">{{item.text}}</Option>
        </Select>
        </Col>
        <Col span="5" v-show="subwayList!=null&&subwayList.length!=0">
        <template>
          <Cascader :data="subwayList" v-model="subwayArr" placeholder="地铁"></Cascader>
        </template>
        </Col>
        </Row>
      <Row :gutter="16">
        <Col span="5" v-show="priceList!=null&&priceList.length!=0">
        <Select :filterable="true"  v-model="rentPrice" placeholder="租金" clearable @on-change="changePrice">
          <Option v-for="(item,index) in priceList" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
        </Select>
        </Col>
        <Col span="5" v-show="houseTypeList!=null&&houseTypeList.length!=0">
        <Select :filterable="true"  v-model="searchData.houseType" placeholder="房型" clearable>
          <Option v-for="(item,index) in houseTypeList" :value="item.value" :key="'keyG'+index">{{item.text}}</Option>
        </Select>
        </Col>
        <Col span="5" v-show="areaList!=null&&areaList.length!=0">
        <Select :filterable="true"  v-model="area" placeholder="面积" clearable @on-change="changeArea">
          <Option v-for="(item,index) in areaList" :value="item.value" :key="'keyC'+index">{{item.text}}</Option>
        </Select>
        </Col>
      </Row>
    </search-group>
  </div>
</template>

<script>
  // import SearchGroup from "components/SearchGroup/index";
  import {initConditionByCityCode,initCityList,initCommonCondition} from "../../../../api/houseType";

  export default {
    name: "SearchList",
    components: {
      // SearchGroup
    },
    data() {
      return {
        subwayArr:[],
        subwayList: [],
        cityList:[],
        areaList:[],
        bizcircleList:[],
        commonCondition:[],
        bizcicleSubline:[],
        priceList:[],
        houseTypeList:[],
        rentPrice:'',
        area:'',
        searchData: {
        }
      };
    },
    methods: {
      findData() {
        if(this.subwayArr){
          this.searchData.subwayLine= this.subwayArr[0];
          this.searchData.subwayStation= this.subwayArr[1];
        }
        this.$emit("findData", this.searchData);
      },
      clearValue() {
        this.subwayArr=[];
        this.searchData= {
        }
        this.rentPrice='';
        this.area='';
        this.searchData.cityCode=this.firstCityCode;
      },
      findCityList(){
        initCityList().then(res=>{
          if(!res.data){
            return
          }
          this.cityList = res.data.cityList;
          this.searchData.cityCode=this.cityList[0].value;
          this.firstCityCode=this.cityList[0].value;
          this.findByCityCode(this.searchData.cityCode);
          this.$emit('findData',this.searchData);
        }).catch(error=>{
        })
      },
      findByCityCode(cityCode){
        var params = {
          'cityCode': cityCode
        }
        initConditionByCityCode(params).then(res=>{
          if(!res.data){
            return
          }
          this.bizcicleSubline=res.data;
          for(var i in this.bizcicleSubline){
            if(this.bizcicleSubline[i].itemKey==3){
              // console.log('=====')
              console.log(this.bizcicleSubline[i].data)

              this.subwayList=this.bizcicleSubline[i].data;
            }
            if(this.bizcicleSubline[i].itemKey==2){
              this.bizcircleList=this.bizcicleSubline[i].data;
            }
          }
        }).catch(error=>{})
      },
      findCommonCondition(){

        initCommonCondition().then(res=>{
          if(!res.data){
            return
          }
          this.commonCondition=res.data;
          for(var i in this.commonCondition){
            if(this.commonCondition[i].itemKey==5){
              this.priceList=this.commonCondition[i].data;
            }
            if(this.commonCondition[i].itemKey==7){
              this.houseTypeList=this.commonCondition[i].data;
            }
            if(this.commonCondition[i].itemKey==6){
              this.areaList=this.commonCondition[i].data;
            }
          }
        }).catch(error=>{})
      },
      changeCity(value) {
        this.searchData.cityCode=value;
        this.findByCityCode(this.searchData.cityCode);
      },
      changePrice(value){
        this.rentPrice=value;
        if(value!=0){
          this.searchData.minPrice=value.split("-")[0];
          this.searchData.maxPrice=value.split("-")[1];
        }
      },
      changeArea(value){
        if(value!=0){
          this.searchData.minArea=value.split("-")[0];
          this.searchData.maxArea=value.split("-")[1];
        }
      }
    },

  created(){
    this.findCityList();
    this.findCommonCondition();

    }

  };
</script>
<style scoped>
  .flex {
    display: block;
  }
  .search-wrapper {
    /*padding: 24px 0 !important;*/
  }

  .shortcut a {
    display: inline-block;
    padding: 10px 20px;
    font-weight: bold;
    color: #444444;
  }

  .width200 {
    width: 200px;
  }

  .width300 {
    width: 300px;
  }

  .block {
    display: block;
  }
  .input-style{
      width: 200px;
      margin-left:50px;
      margin-top:-30px;
  }
  .keyword-style{
     margin-top:20px;
     padding-top:10px;
     width: 40px;
     high:10px;
  }
  .row-style{
    margin-top:20px;
  }
</style>
